<template>
	<div id="lodgingCard">
		<div class="card-container">
			<div class="row row-hubs">
				<div class="col-12">
					<div class="lodging-header text-center">
						<h2 class="merriweather-reg-26">Notre</h2>
						<h2 class="merriweather-reg-40">{{ $t('lodgings') }}</h2>
						<p class="merriweather-light-24 text-center">Hôtels, maisons d’hôtes , villas, lieux insolites… le <span class="merriweather-light-italic-24">privilège</span> de choisir.</p>
					</div>
				    <div class="lodging-filter">
				   <!--<ul class="filter-list">
							<li>
								<a class="lodging-category active" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Hotel">Hôtels</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Guestroom">{{ $t('guestrooms') }}</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Guesthouse">Maisons d'hôtes</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Villa">Villas</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Lodge">Lodges</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Gite">Gîtes</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Appartment">Appartements</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
							<li>
								<a class="lodging-category" href="#" @click.prevent="selectOption"
									><p class="raleway-reg-p16" data-value="Other">{{ $t('unusual') }}</p>
									<img src="../../images/flechedroite.png" alt="flèche droite"
								/></a>
							</li>
						</ul>-->
					</div>
				</div>
				<!--<div class="col-8 pt-2" v-if="lodgingsFiltered">
					<div v-for="(lodging, index) in lodgingsFiltered" :key="index">
						<CardProduct style="margin-bottom: 5px" :wishlist="wishlist" :lodging="lodging" :destination="lodging.destination" :user="isUserConnected()" @connection="$emit('connection')"></CardProduct>
					</div>
					<div v-if="lodgingsFiltered.length" class="pagination-hub d-flex mt-3">
						<a href="#" @click.prevent="loadMoreLodgings" class="link-hortense"> voir plus <img src="../../images/flechebas-simple.svg" v-set-alt /></a>
					</div>
					<p v-else class="raleway-reg-p15 text-left">Hortense est à la recherche d'hébergements à vous proposer</p>
				</div>-->
				
			</div>
			<div class="row-grid">
				<div class="col-hub">
					<div class="card-hub zoom-img-container" @click="goToGroup('/hotel-de-charme')" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+ho%CC%82tels.jpg" alt="NOS hÔTELS" class="zoom-img">
						<p class="merriweather-italic-24">Nos hôtels</p>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" @click="goToGroup('/villa-de-charme')" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+maisons+et+villas.jpg" alt="NOS MAISONS ET VILLAS" class="zoom-img">
						<p class="merriweather-italic-24">Nos maisons<br> et villas</p>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" @click="goToGroup('/chambres-dhotes-de-charme')" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+chambres+hotes.jpg" alt="NOS CHAMBRES D’HÔTES" class="zoom-img">
						<p class="merriweather-italic-24">Nos chambres<br> d’hôtes</p>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" @click="goToGroup('/logement-insolite-de-luxe')" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+lodges+et+lieux+insolites.jpg" alt="NOS LODGES ET LIEUX INSOLITES" class="zoom-img">
						<p class="merriweather-italic-24">Nos lodges et<br>lieux insolites</p>
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" @click="goToGroup('/appartement-de-vacances')" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+appartements.jpg" alt="NOS APPARTEMENTS" class="zoom-img">
						<p class="merriweather-italic-24">Nos appartements</p>
					</div>
				</div>
			</div>
			<div class="row d-flex align-items-center justify-content-center pt-5">
				<a class="hortense-btn-primary raleway-bold-p" :href="'/reservation-hotel'" target="_blank">{{ $t('LodgingCard.view') }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import CardProduct from '../../components/cards/CardProduct.vue';
	import fetcher from 'packs/shared/api.js';

	export default {
		name: 'lodgingCard',
		props: {
			lodgings: Array,
			user: Object,
			wishlist: Object,
		},
		components: { CardProduct },
		data() {
			return {
				lodgingsList: this.lodgings,
				lodgingsFiltered: this.lodgings,
				SelectedOption: 'Hotel',
				lodgingsCurrentPage: 2, // starts at 2 as the first page is loaded by the parent component.
			};
		},
		watch: {
			SelectedOption() {
				// reset current page when switching type
				this.lodgingsCurrentPage = 2;
			},
		},
		methods: {
			goToGroup(url){
				//Turbolinks.visit(url);
				window.open(url, '_blank');
			},
			isUserConnected() {
				return this.user ? this.user : {};
			},
			async loadMoreLodgings(e) {
				const responseLodging = await fetcher.get(`/reservation-hotel?page=${this.lodgingsCurrentPage}&lodgings_count=3&type=${this.SelectedOption}`);
				this.lodgingsCurrentPage++;
				// this.SeeMoreLodging(e);
				this.lodgingsFiltered = this.lodgingsFiltered.concat(responseLodging.data);
			},
			async selectOption(e) {
				const activeEl = document.querySelector('.active');
				activeEl.classList.remove('active');
				e.target.parentNode.classList.add('active');
				this.SelectedOption = e.target.dataset.value;
				if (this.SelectedOption) {
					const responseLodging = await fetcher.get(`/reservation-hotel?page=1&lodgings_count=3&type=${this.SelectedOption}`);
					this.lodgingsFiltered = responseLodging.data;
				} else {
					this.lodgingsFiltered = [];
				}
			},
		},
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-card"></style>

<style scoped>

#lodgingCard {
	padding-top: 70px;
	.lodging-header {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

	.row-hubs {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 1rem;
	}

	.row-grid {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		grid-gap: 20px;
		padding-top: 70px;
	}

	.col-hub {
		flex: 0 0 18%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.card-hub {
		position: relative;
		width: 100%;
		height: 450px;
		cursor: pointer;
	}

	.card-hub img {
		width: 100%;
		height: 450px;
		object-fit: cover;
		background: linear-gradient(180.09deg, rgba(0, 0, 0, 0) 0.08%, rgba(0, 0, 0, 0.3) 99.84%);
		border-radius: 15px;
	}

	.card-hub p {
		position: absolute;
		bottom: 0.5rem;
		left: 0;
		right: 0;
		text-align: center;
		color: white;
	}

	.col-hub:nth-child(odd) .card-hub {
		transform: translateY(-15px);
	}

	.col-hub:nth-child(even) .card-hub {
		transform: translateY(15px);
	}

	.zoom-img-container {
		border-radius: 15px;
	}
}
</style>
